"use strict";function isLocalFileExist$(i){return ddSdk_1.ddSdk.invokeAPI(apiName,i)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.isLocalFileExist$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.isLocalFileExist";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"2.5.0"},_a)),exports.isLocalFileExist$=isLocalFileExist$,exports.default=isLocalFileExist$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/isLocalFileExist.js
// module id = 1011
// module chunks = 106